import React, { Component } from 'react'
var FormatMessage = require('react-globalize').FormatMessage;

export default class TobbacoPurchSalePol extends Component {
  // render() {
  //   return (
  //     <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
  //       <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

  //         <h3 className="text-center">
  //           <FormatMessage locale={this.props.locale} path="footer/tobbacoPurchSalePol" />
  //         </h3>

  //         <hr className="small-blue" />
  //       </div>
  //       <div className="row text-justify">
  //         <div className="col-md-12">

  //           <p>Barri is subject to a number of U.S. Federal and State regulations that govern the types of transactions we are allowed to process. There are several U.S. State and Federal laws regulating the sale of tobacco and tobacco products online or over the phone. For this reason, in the United States, Barri customers may not use our money transfer service for either the sale or purchase of the following items:</p>
  //           <ul>
  //             <li>Any item containing tobacco or tobacco products, such as cigarettes, cigars, or chewing tobacco</li>
  //             <li>Herbal cigarettes or tobacco</li>
  //             <li>Any Hookah or Shisha molasses product that contains tobacco</li>
  //             <li>Nicotine inhalers or sprays</li>
  //             <li>Electronic or smokeless cigarettes</li>
  //           </ul>
  //           <p>Please contact a Barri customer service representative if you have any questions about this policy.</p>

  //         </div>


  //       </div>
  //     </div>
  //   )
  // }

  render() {
    return (
      <div className="container" id="terms-cond-div" style={{ "marginTop": "5%", "marginBottom": "5%" }}>
        <div className="row" style={{ "marginTop": "3%", "marginBottom": "2%" }}>

          <h3 className="text-center">
            <FormatMessage locale={this.props.locale} path="footer/tobbacoPurchSalePol" />
          </h3>

          <hr className="small-blue" />
        </div>
        <div className="row text-justify">
          {
            this.props.locale == "en"?
          <div className="col-md-12">
            <p>Barri is subject to a number of U.S. Federal and State regulations that govern the types of transactions we are allowed to process. There are several U.S. State and Federal laws regulating the sale of tobacco and tobacco products online or over the phone. For this reason, in the United States, Barri customers may not use our money transfer service for either the sale or purchase of the following items:</p>
            <ul>
              <li>Any item containing tobacco or tobacco products, such as cigarettes, cigars, or chewing tobacco</li>
              <li>Herbal cigarettes or tobacco</li>
              <li>Any Hookah or Shisha molasses product that contains tobacco</li>
              <li>Nicotine inhalers or sprays</li>
              <li>Electronic or smokeless cigarettes</li>
            </ul>
            <p>Please contact a Barri customer service representative if you have any questions about this policy.</p>
          </div>:
          <div className="col-md-12">
            <p>
              Barri está sujeto a una serie de regulaciones federales y estatales de EE.UU. Que rigen los tipos de transacciones que podemos procesar. Hay varias leyes estatales y federales de EE.UU. Que regulan la venta de tabaco y productos de tabaco en línea o por teléfono.
              Por esta razón, en los Estados Unidos de América, los clientes de Barri no pueden usar nuestro servicio de transferencia de dinero ni para la venta ni para la compra de los siguientes artículos:
              </p>
            <ul>
              <li>Cualquier artículo que contenga tabaco o productos de tabaco, como cigarrillos, cigarros o tabaco de mascar</li>
              <li>Cigarrillos de hierbas o tabaco</li>
              <li>Cualquier producto de melazas Hookah o Shisha que contenga tabaco</li>
              <li>Inhaladores o aerosoles de nicotina</li>
              <li>Cigarrillos electrónicos o sin humo</li>
            </ul>
            <p>Póngase en contacto con un representante de servicio al cliente de Barri si tiene alguna pregunta sobre esta política.</p>
          </div>
          }
        </div>
      </div>
    )
  }  
}



// WEBPACK FOOTER //
// ./js/TobbacoPurchSalePol.js